/**
 * Article Products
 *
 * 1. Inline products: places the block into the article richtext at a marker
 *    (<div class="blog-inline-products"></div>) or after the 2nd <h2>.
 *
 * 2. Swiper: initializes mobile sliders for inline + sidebar.
 *
 * 3. Smart bidirectional sticky sidebar:
 *    - Scroll DOWN → sidebar scrolls up naturally, then sticks when bottom is visible
 *    - Scroll UP   → sidebar scrolls down naturally, then sticks when top is visible
 *    - Constrained within the article body container
 */
(function () {
  /**
   * Phase 1 — placement DOM (s'exécute dès DOMContentLoaded pour éviter
   * le flash du bloc inline en haut de l'article sur connexion lente).
   */
  function initEarly() {
    placeInlineProducts();
  }

  /**
   * Phase 2 — calculs de layout / Swiper (sur window.load car dépend
   * des images chargées et de la lib Swiper).
   */
  function initLate() {
    initSmartSticky();
    initSwipers();
  }

  /* ------------------------------------------------------------------
     Inline products placement
     ------------------------------------------------------------------ */
  function placeInlineProducts() {
    var inlineBlock = document.querySelector('.article-inline-products');
    if (!inlineBlock) return;

    var richtext = document.querySelector('.maa-template__richtext, .bpdp-body');
    if (!richtext) return;

    var marker = richtext.querySelector('.blog-inline-products');
    if (marker) {
      marker.replaceWith(inlineBlock);
    } else {
      var headings = richtext.querySelectorAll('h2');
      if (headings.length >= 3) {
        // Insert above the 3rd h2
        richtext.insertBefore(inlineBlock, headings[2]);
      } else if (headings.length >= 2) {
        // Insert above the 2nd h2
        richtext.insertBefore(inlineBlock, headings[1]);
      } else {
        richtext.appendChild(inlineBlock);
      }
    }

    // Révéler le bloc une fois placé (cf. .article-inline-products dans
    // component-article-products.css qui le masque par défaut).
    inlineBlock.classList.add('article-inline-products--placed');
  }

  /* ------------------------------------------------------------------
     Swiper init (mobile)
     ------------------------------------------------------------------ */
  function initSwipers() {
    if (typeof Swiper === 'undefined') return;

    var cfg = {
      loop: false,
      spaceBetween: 20,
      slidesPerView: 1.33,
      breakpoints: {
        480: { slidesPerView: 1.5, spaceBetween: 20 },
        640: { slidesPerView: 2.33, spaceBetween: 20 },
      },
    };

    if (document.querySelector('.swiper-article-inline-products') && window.innerWidth < 750) {
      new Swiper('.swiper-article-inline-products', cfg);
    }

    if (document.querySelector('.swiper-article-sidebar-products')) {
      new Swiper('.swiper-article-sidebar-products', cfg);
    }
  }

  /* ------------------------------------------------------------------
     Smart bidirectional sticky sidebar
     Uses position: fixed / absolute / static to handle scroll in both
     directions without jumps.

     States:
       STATIC     – inner at default position (top of outer)
       FIXED_TOP  – inner fixed to viewport top
       FIXED_BOT  – inner fixed to viewport bottom
       ABS        – inner positioned absolutely inside outer (freeze)
     ------------------------------------------------------------------ */
  function initSmartSticky() {
    var outer = document.querySelector('.article-sidebar-products--desktop');
    console.log('[sidebar] outer:', outer);
    if (!outer) return;

    var inner = outer.querySelector('.article-sidebar-products__inner');
    console.log('[sidebar] inner:', inner);
    if (!inner) return;

    console.log('[sidebar] innerH:', inner.offsetHeight, 'outerH:', outer.offsetHeight, 'viewH:', window.innerHeight);

    var content = outer.parentElement.querySelector('.maa-template__body-content');

    var GAP = 30; // px breathing room top & bottom
    var state = 'STATIC';
    var lastScrollY = window.scrollY;
    var absTop = 0; // used in ABS state
    var cachedWidth = 0;

    function measure() {
      var outerRect = outer.getBoundingClientRect();
      return {
        innerH: inner.offsetHeight,
        outerH: outer.offsetHeight,
        outerTop: outerRect.top + window.scrollY,
        outerLeft: outerRect.left,
        outerW: outer.offsetWidth,
        viewH: window.innerHeight,
        scrollY: window.scrollY,
      };
    }

    /**
     * Article court : si la sidebar est au moins aussi haute que la colonne de
     * texte, elle n'a aucune place pour suivre le défilement. La sortir du flux
     * réduirait en plus le conteneur à la hauteur du texte, et le calage en bas
     * du conteneur la ferait remonter par-dessus l'en-tête de l'article.
     */
    function hasRoomToStick() {
      return !content || content.offsetHeight > inner.offsetHeight;
    }

    function applyState(m) {
      switch (state) {
        case 'STATIC':
          inner.style.position = '';
          inner.style.top = '';
          inner.style.bottom = '';
          inner.style.width = '';
          inner.style.left = '';
          break;

        case 'FIXED_TOP':
          inner.style.position = 'fixed';
          inner.style.top = GAP + 'px';
          inner.style.bottom = '';
          inner.style.width = cachedWidth + 'px';
          inner.style.left = m.outerLeft + 'px';
          break;

        case 'FIXED_BOT':
          inner.style.position = 'fixed';
          inner.style.top = '';
          inner.style.bottom = GAP + 'px';
          inner.style.width = cachedWidth + 'px';
          inner.style.left = m.outerLeft + 'px';
          break;

        case 'ABS':
          inner.style.position = 'absolute';
          inner.style.top = absTop + 'px';
          inner.style.bottom = '';
          inner.style.width = cachedWidth + 'px';
          inner.style.left = '0';
          break;
      }
    }

    var scrollLogCount = 0;
    function onScroll() {
      if (window.innerWidth < 990) {
        if (state !== 'STATIC') {
          state = 'STATIC';
          applyState(measure());
        }
        return;
      }

      if (!hasRoomToStick()) {
        if (state !== 'STATIC') {
          state = 'STATIC';
          applyState(measure());
        }
        lastScrollY = window.scrollY;
        return;
      }

      var scrollY = window.scrollY;
      var delta = scrollY - lastScrollY;
      if (delta === 0) return;

      var oldState = state;
      lastScrollY = scrollY;

      var m = measure();
      cachedWidth = m.outerW;
      var innerRect = inner.getBoundingClientRect();

      // If sidebar fits in viewport, simple sticky top
      if (m.innerH <= m.viewH - GAP * 2) {
        if (innerRect.top <= GAP && state !== 'FIXED_TOP') {
          state = 'FIXED_TOP';
          applyState(m);
        } else if (innerRect.top > GAP && state === 'FIXED_TOP') {
          state = 'STATIC';
          applyState(m);
        }
        clampToContainer(m);
        return;
      }

      // ---- Bidirectional sticky for tall sidebars ----
      if (delta > 0) {
        // Scrolling DOWN → reveal bottom of sidebar
        if (state === 'STATIC') {
          // Sidebar bottom reached viewport bottom → fix at bottom
          if (innerRect.bottom <= m.viewH - GAP) {
            state = 'FIXED_BOT';
            applyState(m);
          }
        } else if (state === 'FIXED_TOP') {
          // Freeze at current position, let content scroll past
          absTop = scrollY - m.outerTop + GAP;
          state = 'ABS';
          applyState(m);
        } else if (state === 'ABS') {
          // Check: has sidebar bottom reached viewport bottom?
          if (innerRect.bottom <= m.viewH - GAP) {
            state = 'FIXED_BOT';
            applyState(m);
          }
        }
        // FIXED_BOT: stay put
      } else {
        // Scrolling UP → reveal top of sidebar
        if (state === 'STATIC') {
          // Sidebar top reached viewport top → fix at top
          if (innerRect.top >= GAP && innerRect.top <= GAP + 5) {
            state = 'FIXED_TOP';
            applyState(m);
          }
        } else if (state === 'FIXED_BOT') {
          // Freeze at current position
          absTop = scrollY + m.viewH - GAP - m.innerH - m.outerTop;
          state = 'ABS';
          applyState(m);
        } else if (state === 'ABS') {
          // Check: has sidebar top reached viewport top?
          if (innerRect.top >= GAP) {
            state = 'FIXED_TOP';
            applyState(m);
          }
        }
        // FIXED_TOP: stay put
      }

      clampToContainer(m);

      if (state !== oldState || scrollLogCount < 5) {
        console.log('[sidebar] state:', oldState, '->', state, '| delta:', delta > 0 ? 'DOWN' : 'UP',
          '| innerRect.top:', Math.round(innerRect.top), '| innerRect.bottom:', Math.round(innerRect.bottom),
          '| innerH:', m.innerH, '| viewH:', m.viewH, '| outerH:', m.outerH);
        scrollLogCount++;
      }
    }

    /**
     * Prevent the sidebar from overflowing its container (article body).
     * When the article ends, the sidebar must stop.
     */
    function clampToContainer(m) {
      var containerBottom = m.outerTop + m.outerH;

      if (state === 'FIXED_BOT') {
        // If container bottom is above where the fixed sidebar would end
        var fixedBottom = m.scrollY + m.viewH - GAP;
        if (fixedBottom > containerBottom) {
          absTop = Math.max(0, m.outerH - m.innerH);
          state = 'ABS';
          applyState(m);
        }
      }

      if (state === 'FIXED_TOP') {
        // If container bottom is above where the fixed sidebar would end
        var fixedTop = m.scrollY + GAP;
        var fixedEnd = fixedTop + m.innerH;
        if (fixedEnd > containerBottom) {
          absTop = Math.max(0, m.outerH - m.innerH);
          state = 'ABS';
          applyState(m);
        }
        // If we're above the container
        if (fixedTop < m.outerTop) {
          state = 'STATIC';
          applyState(m);
        }
      }

      // Clamp absolute position
      if (state === 'ABS') {
        if (absTop < 0) {
          absTop = 0;
          applyState(m);
        }
        if (absTop > 0 && absTop + m.innerH > m.outerH) {
          absTop = Math.max(0, m.outerH - m.innerH);
          applyState(m);
        }
      }
    }

    function onResize() {
      state = 'STATIC';
      var m = measure();
      cachedWidth = m.outerW;
      applyState(m);
      lastScrollY = window.scrollY;
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', debounce(onResize, 150));

    // Initial state
    var m = measure();
    cachedWidth = m.outerW;
    if (window.innerWidth >= 990 && hasRoomToStick() && m.innerH <= m.viewH - GAP * 2) {
      var innerRect = inner.getBoundingClientRect();
      if (innerRect.top <= GAP) {
        state = 'FIXED_TOP';
        applyState(m);
      }
    }
  }

  /* ------------------------------------------------------------------
     Utils
     ------------------------------------------------------------------ */
  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEarly);
  } else {
    initEarly();
  }
  window.addEventListener('load', initLate);
})();
